import React, { useContext } from "react";
import Header from "./header";
import Counter from "./countertext";
import Footer from "./footer";
import { useState, useEffect } from "react";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import HomeCounters from "./Homecounters";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import CitySelector from "./User/CitySelectore";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";

function OPCcompanyregistration() {


   useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
         const parsedUser = JSON.parse(storedUser);
         setNewData((prevData) => ({
            ...prevData,
            user_name: parsedUser.name || "",
            user_email: parsedUser.email || "",
            user_contact_number: parsedUser.mobile || "",
            user_city: parsedUser.city || "",
         }));
      }
   }, []);

   const [activeQuestion, setActiveQuestion] = useState(null);
   const { http, token } = AuthUser();
   const navigate = useNavigate();
   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };

   const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact_number: '', user_city: '' })

   const [errors, setErrors] = useState({});

   const { services, loading, error } = useContext(ServicesContext);
   if (loading) {
      return <div>Loading...</div>;  // Show loading state while fetching data
   }

   if (error) {
       return <div>{error}</div> // Show error state if there was an issue fetching data
   }
   const service = services.find(s => s.service_id === 6);

   const validateForm = () => {
      const newErrors = {};

      if (!newData.user_name.trim()) {
         newErrors.user_name = 'Name is required.';
      } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
         newErrors.user_name = '*Name should only contain letters and spaces.';
      }

      if (!newData.user_email.trim()) {
         newErrors.user_email = 'Email is required.';
      } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
         newErrors.user_email = 'Enter a valid email address.';
      }

      //  if (newData.user_contact_number && !/^\d{10}$/.test(newData.user_contact_number)) {
      //     newErrors.user_contact_number = 'Enter a valid 10-digit contact number.';
      //  }
      if (!newData.user_contact_number.trim()) {
         newErrors.user_contact_number = 'number is required.';
      } else if (!/^\d{10}$/.test(newData.user_contact_number)) {
         newErrors.user_contact_number = 'Enter a valid 10-digit contact number.';
      }

      if (!newData.user_city) {
         newErrors.user_city = 'City/District is required.';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // No errors
   };




   const formPutPartenshipdeed = async (e) => {
      e.preventDefault();
      // ✅ Check if user is logged in
      // if (!token) {
      //    alert("Please log in to continue.");
      //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
      //    navigate('/login'); // 👈 Use this if you're using React Router
      //    return;
      // }
      if (!validateForm()) return;

      localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });

   };



   return (
      <div>


         <div className="hero-area10 header-background">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2 ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                        </div>
                        <p className="pdrl-text"><img src="assets/img/image/Line.png" className="line-image" /> <span className="text-color">250k+</span> <span>People trust us</span></p>
                        <h1 className="sk-text-color">One Person Company (OPC) Registration</h1>
                        <p className="pdrl-text">Get OPC Registration for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Govt. Fees As per actual Extra)</span></p>
                        <p className="pd-text">Government fees and stamp duties are extra. Please fill out the form to receive a detailed quote in seconds. </p>
                        <p className="pd-text text-center star-text">Within 2 Weeks <span><img className="star" src="assets/image/star.svg" alt="" /></span> Transparent Pricing <span><img className="star" src="assets/image/star.svg" alt="" /></span> No Hidden Fees.</p>
                        <div className="couter-all">

                           <div className="row package-section">
                              <p className="ps-text">Get Absolutely Free In Package</p>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/pan-tax-registration.svg" />
                                    <p>Pan & TAN Registration</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/din-and-dsc-for-directors.svg" />
                                    <p>DIN and DSC for Directors</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/complete-document.svg" />
                                    <p>Complete Documentation</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/personal-assistance.svg" />
                                    <p>Personal Assistance</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box dis">
                                    <img src="assets/img/image/pf-and-esc-registration.svg" />
                                    <p>PF and ESIC Registration</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                     <div className="contact3-form-all">
                        <div className="hadding7">
                           <h3>One Person Company Registration
                           </h3><p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Govt. Fees As per actual Extra)</span></p>
                        </div>
                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                             <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Email Address<span className="red">*</span></label>{errors.user_email && <p className="error-text">{errors.user_email}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Contact Number<span className="red">*</span></label>{errors.user_contact_number && <p className="error-text">{errors.user_contact_number}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact_number} onChange={(e) => setNewData({ ...newData, user_contact_number: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">
                                       <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_city"
                                          errors={errors}
                                       />
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2">
                                 <a className="theme-btn-3 btn-color" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space60 bg-white"></div>

         <div className="home4-counters bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-md-12">


                     <HomeCounters />
                  </div>
               </div>


               <div className="space40"></div>
               <div className="row">
                  <div className="col-lg-12">

                  </div>
                  <div className="col-lg-8">

                     <p className="pd-text">Want to start a company on your own? No worries! The One Person Company (OPC) in India is a unique business structure introduced under the Companies Act, 2013. As per Section 2(62), it allows a single individual to establish a company with just one director and one member.</p>
                     <p className="pd-text">In an OPC, the director and member can be the same individual. It provides the benefits of a company structure while requiring less compliance than a private limited company. This makes it an ideal choice for both residents and NRIs looking to establish a business that merges the advantages of a sole proprietorship with the features of a corporate entity.</p>

                     <p className="pd-text">Why wait? Start your One Person Company with Dm2Legal today! Our expert team will manage everything—from paperwork to document verification—so you can focus on your business while we handle the legalities. Take the first step toward success with Dm2Legal!</p>
                  </div>
                  <div className="col-lg-4">
                     <img src="assets/img/service/service7-main-image.png" alt="" />
                  </div>
               </div>
               <div className="space20"></div>

            </div>
         </div>

         <div className="space40 bg-white"></div>
         <div className="service-binifits9 sp0 last-section" id="service2" >
            <div className="space50"></div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Comparison </h2>
                        <div className="space40"></div>
                        <h6 className="hedaing-text">All Service Comparison</h6>
                        <h3 className="hedaing-text-1">Proprietorship vs Limited Liability Partnership (LLP) vs Company</h3>
                        <div className="pro-llp-com-table">
                           <table>
                              <thead>
                                 <tr className="table-heading">
                                    <th>Features</th>
                                    <th>Proprietorship</th>
                                    <th>Partnership</th>
                                    <th>LLP</th>
                                    <th>Company</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr>
                                    <td>Ownership</td>
                                    <td>In a proprietorship, a single individual owns and manages the entire business, making all decisions and retaining full control and responsibility for its operations.</td>
                                    <td>A partnership involves two or more individuals (partners) who share the ownership, management, and responsibilities of the business. Each partner contributes to the business, and profits and losses are typically shared based on the terms outlined in the partnership agreement.</td>
                                    <td>In a partnership, partners generally have unlimited liability, meaning their personal assets can be used to settle business debts or liabilities. This differs from structures like a limited liability company (LLC), where personal assets are protected.</td>
                                    <td>A company is a legal entity distinct from its owners (shareholders). Shareholders enjoy limited liability, meaning their personal assets are generally protected from the company's debts and liabilities.</td>
                                 </tr>
                                 <tr>
                                    <td>Definition</td>
                                    <td>A sole proprietorship is a business owned and operated by a single individual, who has full control over its operations and decisions.</td>
                                    <td>A partnership is a legal arrangement in which two or more individuals or entities come together to share ownership, responsibilities, profits, and liabilities of a business.</td>
                                    <td>An LLP (Limited Liability Partnership) is a hybrid business structure that combines aspects of both partnerships and companies. It provides limited liability to its partners, meaning their personal assets are protected from the business’s liabilities.</td>
                                    <td>A company is a legal entity distinct from its owners (shareholders). It can be structured as a private limited company or a public limited company. Shareholders are the owners of the company, and their liability is limited to their investment in the company.</td>
                                 </tr>
                                 <tr>
                                    <td>Registration Time</td>
                                    <td></td>
                                    <td></td>
                                    <td>7-15 working days</td>
                                    <td></td>
                                 </tr>
                                 <tr>
                                    <td>Promoter Liability</td>
                                    <td></td>
                                    <td>Unlimited Liability</td>
                                    <td></td>
                                    <td>Limited Liability</td>
                                 </tr>
                                 <tr>
                                    <td>Governance</td>
                                    <td>Governed by Local Laws</td>
                                    <td>Under Partnership Act, 1932</td>
                                    <td>LLP Act, 2008</td>
                                    <td>Under Companies Act,2013</td>
                                 </tr>
                                 <tr>
                                    <td>Compliance Requirements</td>
                                    <td>Compliance with Income Tax Laws and other local laws is essential for any business entity to operate legally and avoid penalties.</td>
                                    <td>Compliance with Income Tax Laws and other local laws is essential for any business entity to operate legally and avoid penalties.</td>
                                    <td>Compliance with Income Tax Laws, Local Laws, the Companies Act, and other applicable regulations is critical for businesses to operate within the legal framework and avoid penalties.</td>
                                    <td>Compliance with Income Tax Laws, Local Laws, the Companies Act, and other applicable regulations is critical for businesses to operate within the legal framework and avoid penalties.</td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
                  <div className="space30"></div>
               </div>
            </div>
         </div>

         <div className="service-binifits9 sp0 bg-white" >
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">How to apply</h2>
                        <div className="space20"></div>
                        <img src="assets/img/images/OPC-Company-Registration.png" />
                     </div>
                     <div className="space20"></div>
                  </div>
               </div>
            </div>
         </div>
         <div className="space20 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <h2 className="aos-init aos-animate text-center">Benefits </h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon1.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Limited Liability</a></h4>
                           <p className="font-f-7">The primary benefit of registering an OPC is that it offers limited liability protection to the sole member. This ensures that the member's personal assets are kept separate from the company's liabilities. In the event of financial losses or legal issues, the member's personal assets are protected from the company's obligations.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon2.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Single Ownership and Management</a></h4>
                           <p className="font-f-7">OPC allows an individual to both form and manage a company on their own. This is ideal for entrepreneurs who wish to run a business independently, without the need for additional shareholders or partners. The sole member has full control over the company's operations and decision-making process.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon3.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Separate Legal Entity</a></h4>
                           <p className="font-f-7">An OPC is regarded as a separate legal entity from its owner, meaning it has its own identity distinct from the individual member. This separation enhances the business’s credibility, making it easier to enter into contracts, raise funds, and establish professional relationships. </p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon5.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Perpetual Succession</a></h4>
                           <p className="font-f-7">OPC registration guarantees perpetual succession, meaning the company will continue to exist even if the owner or promoter passes away or becomes incapacitated. The company's shares can be transferred to a nominee, as specified in the incorporation documents, ensuring the continuity of the business.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon6.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Easy Funding and Bank Loans</a></h4>
                           <p className="font-f-7">OPCs have easier access to funding and bank loans compared to sole proprietorships or partnerships. Financial institutions and investors view OPCs as more credible and are more likely to provide financial support. OPCs can raise funds through equity or debt and have the ability to issue shares to investors.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/brand6-4.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Tax Advantages</a></h4>
                           <p className="font-f-7">OPCs benefit from various tax advantages. They are eligible for tax deductions, exemptions, and benefits available to other types of companies. OPCs are taxed at the corporate tax rate, which is often lower than individual tax rates, potentially leading to significant tax savings.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon4.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Minimal Compliance Requirements</a></h4>
                           <p className="font-f-7">OPCs have fewer compliance requirements compared to other types of companies. They are exempt from certain statutory obligations, such as holding annual general meetings (AGMs) with shareholders, making the regulatory process simpler and more cost-effective.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/work6-icon3.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Easy Conversion</a></h4>
                           <p className="font-f-7">As an OPC expands, it can be easily converted into a private limited company, offering advantages like the ability to include more shareholders and access greater capital. The conversion process is simple and provides flexibility for future growth and expansion.</p>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="space20"></div>
            </div>
         </div>

         <Testimonials />

         <div className="service-binifits9 sp0" id="service2">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space50"></div>
                        <h2 className="text-center">Registration Process</h2>
                        <div className="space20"></div>
                        <img src="assets/img/images/Group-8586.png" alt="" />
                     </div>
                     <div className="space50"></div>
                  </div>
               </div>
            </div>
         </div>



         <div className="bg-white">

            <div className="container">
               <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                              <div className="space30"></div>
                              <div id="general">

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >
                                       Q1: Who is eligible to register a One Person Company (OPC) in India?
                                       <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Any Indian citizen who is a resident of India can register an OPC, but they cannot be a member of more than one OPC at a time.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                       Q2: Is there a minimum capital requirement for OPC registration?
                                       <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          No, there is no minimum capital requirement for registering an OPC, but the initial capital must be declared during incorporation.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                       Q3: Is it possible for an OPC to have multiple directors?
                                       <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Yes, an OPC can have more than one director, but it can only have one shareholder as per the Companies Act, 2013.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                       Q4: Does an OPC require a nominee for registration?
                                       <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">Yes, an OPC must appoint a nominee, who will take over in case of the owner’s death or incapacity, as per the Companies Act, 2013.</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                       Q5: Is it possible to convert an OPC into a Private Limited Company?
                                       <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Yes, an OPC can be converted into a Private Limited Company voluntarily or mandatorily if its paid-up capital exceeds ₹50 lakh or turnover crosses ₹2 crore. </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6: Does an OPC need to get its accounts audited?
                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Yes, an OPC must get its accounts audited if its turnover exceeds ₹2 crore or paid-up capital exceeds ₹50 lakh, as per the Companies Act, 2013.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(7)}
                                    >
                                       Q7: What are the mandatory compliance requirements for an OPC?
                                       <span>
                                          {activeQuestion === 7 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          An OPC must file annual returns (MGT-7A), financial statements (AOC-4), maintain statutory records, and get an audit if turnover exceeds ₹2 crore.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(8)}
                                    >
                                       Q8: Is an OPC allowed to have multiple branches?
                                       <span>
                                          {activeQuestion === 8 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Yes, an OPC can open branches in different locations, but all operations must be reported under the same legal entity.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 9 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(9)}
                                    >
                                       Q9: Can an OPC be changed into a Sole Proprietorship or Partnership?
                                       <span>
                                          {activeQuestion === 9 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 9 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          No, an OPC cannot be directly converted into a Sole Proprietorship or Partnership, but it can be closed and a new entity can be formed.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 10 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(10)}
                                    >
                                       Q10: What is the timeline for OPC registration?
                                       <span>
                                          {activeQuestion === 10 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 10 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Registering an OPC typically takes 7 to 10 days, depending on document verification and MCA processing time.                                        </p>
                                    </div>
                                 </div>


                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-7 m-auto text-center">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <h2 className="aos-init aos-animate">Why Choose Us?</h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                           <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                           <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                           <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                           <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                           <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         <WhatsAppScrollButton />
         <Footer />
         <CircularScrollProgress />

      </div>

   );
}
export default OPCcompanyregistration;